/**
 * Profile Constants - Shared constants for profile admin components
 *
 * Widget definitions and icon mappings extracted from ProfileAdminView
 * to avoid circular imports and centralise data.
 */

import {
  Car, Users, Wrench, Fuel, FileText, AlertTriangle, Shield, CreditCard,
  MapPin, BarChart3, TrendingUp, LayoutDashboard, ClipboardCheck, ShieldCheck,
  Hammer, Building2, UserCog, Bell, ListChecks, Receipt, Truck, UserCheck,
  Calendar, Gauge, Share2, ShieldAlert, Mail, Archive, Megaphone, Radar, Box,
  Table2, UserCircle, Eye
} from 'lucide-react';

// Widget definitions for dashboard
export const ALL_WIDGETS = [
  { id: 'kpi_overview', label: 'Vue KPI' },
  { id: 'alerts_priority', label: 'Alertes prioritaires' },
  { id: 'vehicles_status', label: 'Statut flotte' },
  { id: 'drivers_availability', label: 'Disponibilité conducteurs' },
  { id: 'sites_overview', label: 'Aperçu sites' },
  { id: 'quick_actions', label: 'Actions rapides' },
  { id: 'upcoming_deadlines', label: 'Échéances' },
  { id: 'costs_month', label: 'Coûts du mois' },
  { id: 'claims_open', label: 'Sinistres ouverts' },
  { id: 'recent_activity', label: 'Activité récente' },
  { id: 'resource_alerts', label: 'Alertes fluides & usures' },
];

// Module icon mapping (view_code -> Lucide component)
export const MODULE_ICONS = {
  dashboard: LayoutDashboard,
  vehicles: Car,
  drivers: Users,
  maintenance: Wrench,
  fuel: Fuel,
  inspections: ClipboardCheck,
  insurance: Shield,
  claims: AlertTriangle,
  documents: FileText,
  compliance: ShieldCheck,
  costs: CreditCard,
  reports: BarChart3,
  telematics: MapPin,
  tools: Hammer,
  analytics: TrendingUp,
  alerts: Bell,
  pipeline: ListChecks,
  sites: Building2,
  fines: Receipt,
  suppliers: Truck,
  assignments: UserCheck,
  events: Calendar,
  cockpit: Gauge,
  shares: Share2,
  'risk-profiles': ShieldAlert,
  emails: Mail,
  'report-archive': Archive,
  campaigns: Megaphone,
  radar: Radar,
};

// Icon name string -> Lucide component resolver
export const ICON_BY_NAME = {
  LayoutDashboard, Car, Users, Wrench, Fuel, ClipboardCheck, Shield,
  AlertTriangle, FileText, ShieldCheck, CreditCard, BarChart3, MapPin,
  Hammer, TrendingUp, Bell, ListChecks, Building2, Receipt, Truck,
  UserCheck, Calendar, Gauge, Share2, ShieldAlert, Mail, Archive,
  Megaphone, Radar, Box, Table2, UserCircle, Eye,
};

// Profile icon mapping
export const PROFILE_ICONS = {
  Table2,
  UserCircle,
  Building2,
  UserCog,
  BarChart3,
  Eye,
};

// Resolve a Lucide component from a string icon name
export function resolveIcon(iconName) {
  return ICON_BY_NAME[iconName] || MODULE_ICONS[iconName] || Box;
}
